<template>
  <div :class="[colSizes, 'mb-3']">
    <router-link
      tag="div"
      :to="{
        name: ROUTE_CATEGORY_DETAIL,
        params: { id: id, name: category.name }
      }"
      :id="id"
      class="card card-colorful"
      :style="{ backgroundColor: '#' + category.color + 'ff' }"
    >
      <h5 class="card-header">
        {{ category.name }}
        <span class="badge badge-secondary float-right">
          {{ amountInCategory(id) }}
        </span>
      </h5>
      <div class="card-body">
        <p class="card-text">
          maybe we will list first few items here...
        </p>
        <!--<a href="#" class="btn btn-primary">Choj do rici</a>-->
      </div>
    </router-link>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  ROUTE_CATEGORY_DETAIL,
  COL_SIZES_CARD_FULL_WIDTH
} from "./../../constants";

export default {
  name: "CategoryCard",
  data() {
    return { ROUTE_CATEGORY_DETAIL };
  },
  computed: {
    ...mapGetters(["amountInCategory"])
  },
  props: {
    category: { type: Object, required: true },
    id: { type: String, required: true },
    colSizes: {
      type: String,
      required: false,
      default() {
        return COL_SIZES_CARD_FULL_WIDTH;
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
